import { UNSELECTED_OPTION_VALUE } from '@fieldEngine';
import { OWNER_PLACEHOLDER } from '../constants';

export function buildOwnerOptions(users, currentUserId, currentUser) {
  const seenUserIds = new Set();
  const ownerOptions = users.reduce((options, user) => {
    const userId = String(user.id);
    if (seenUserIds.has(userId)) return options;
    seenUserIds.add(userId);
    options.push({
      key: userId,
      value: user.displayName ?? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim(),
    });
    return options;
  }, []);

  if (currentUserId && !ownerOptions.some((option) => option.key === currentUserId)) {
    const selfLabel =
      `${currentUser?.firstName ?? ''} ${currentUser?.lastName ?? ''}`.trim()
      || currentUser?.username
      || 'Me';
    ownerOptions.unshift({ key: currentUserId, value: selfLabel });
  }

  if (ownerOptions.length === 0) return [];

  return [{ key: UNSELECTED_OPTION_VALUE, value: OWNER_PLACEHOLDER }, ...ownerOptions];
}
